import { createFileRoute } from "@tanstack/react-router";
import { SupplyWeek } from "./-components/supply-week";

export const Route = createFileRoute("/_authenticated/supplies/calendar")({
  component: SupplyWeek,
});
